/**
 * HESTIA cart engine
 * - Fast ATC drawer open
 * - Trash removes ONE deal (paid stick + free stick + bag + mystery), not the whole cart
 * - Orphan gifts never linger
 */
(function () {
  var HESTIA_PRODUCT_ID = 15435057496152;
  var GIFT_PRODUCT_IDS = { bag: 15442060705880, mystery: 15424148635736 }; // Moosh Makeup Bag
  var GIFT_VARIANT_IDS = { bag: 67799775117400, mystery: 67688432369752 }; // default Pink
  // Every gift variant that must never checkout alone (Beige + Pink + legacy travel bag)
  var ALL_BAG_VARIANT_IDS = [67799775117400, 67799775084632, 67755739840600, 67755739873368];
  var LEGACY_BAG_PRODUCT_IDS = [15437535084632];
  var ALL_GIFT_VARIANT_IDS = ALL_BAG_VARIANT_IDS.concat([GIFT_VARIANT_IDS.mystery]);
  var ALL_GIFT_PRODUCT_IDS = [GIFT_PRODUCT_IDS.bag, GIFT_PRODUCT_IDS.mystery].concat(LEGACY_BAG_PRODUCT_IDS);

  var syncing = false;
  var claiming = false;
  var removingBundle = false;
  var lastOpenAt = 0;
  var lastCart = null;
  var refreshTimer = null;

  var pageScrollLocked = false;
  var touchGuardBound = false;

  function lockPageScroll() {
    if (pageScrollLocked) {
      document.documentElement.classList.add('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
      document.body.classList.add('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
      return;
    }
    var y = window.scrollY || window.pageYOffset || 0;
    document.documentElement.dataset.hestiaScrollY = String(y);
    document.documentElement.classList.add('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
    document.body.classList.add('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
    document.body.style.top = '-' + y + 'px';
    pageScrollLocked = true;
    bindTouchScrollGuard();
  }

  function unlockPageScroll() {
    if (!pageScrollLocked && !document.documentElement.classList.contains('hestia-scroll-locked')) {
      document.documentElement.classList.remove('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
      document.body.classList.remove('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
      document.body.style.top = '';
      return;
    }
    var y = parseInt(document.documentElement.dataset.hestiaScrollY || '0', 10) || 0;
    document.documentElement.classList.remove('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
    document.body.classList.remove('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
    document.body.style.top = '';
    pageScrollLocked = false;
    delete document.documentElement.dataset.hestiaScrollY;
    window.scrollTo(0, y);
  }

  function isInsideCartItemsScroller(target) {
    if (!target || !target.closest) return false;
    var zone = target.closest('cart-drawer-items');
    if (!zone) return false;
    return zone.scrollHeight > zone.clientHeight + 1 || true; // always allow items zone to receive gesture
  }

  function onCartTouchMove(e) {
    if (!pageScrollLocked && !document.documentElement.classList.contains('hestia-cart-open')) return;
    // Allow native pan inside the cart items scroller; block page/background scroll everywhere else.
    if (isInsideCartItemsScroller(e.target)) return;
    // Allow tiny interactions inside drawer chrome without moving the page
    if (e.cancelable) e.preventDefault();
  }

  function bindTouchScrollGuard() {
    if (touchGuardBound) return;
    touchGuardBound = true;
    document.addEventListener('touchmove', onCartTouchMove, { passive: false, capture: true });
    document.addEventListener('wheel', onCartTouchMove, { passive: false, capture: true });
  }


  function routesRoot() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    } catch (e) {
      return '/';
    }
  }

  function cartUrl(path) {
    return routesRoot().replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    var now = Date.now();
    // Debounce only when already open — still allow first open to animate.
    if (now - lastOpenAt < 250 && d.classList.contains('active')) return;
    lastOpenAt = now;
    lockPageScroll();

    // Prefer theme CartDrawer.open() (setTimeout before active) for native slide.
    if (typeof d.open === 'function') {
      try {
        // Ensure we start from the closed transform so the transition can run.
        if (!d.classList.contains('active')) {
          d.classList.remove('active');
          d.classList.add('animate');
        }
        d.open(document.querySelector('#cart-icon-bubble'));
        return;
      } catch (err) {}
    }

    // Fallback: paint off-screen (animate, not active), then slide in on next frames.
    d.classList.remove('active');
    d.classList.add('animate');
    // Force layout so translate3d(100%) is committed before .active
    void d.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('active');
      });
    });
  }

  function closeDrawer() {
    var d = getDrawer();
    unlockPageScroll();
    if (d && typeof d.close === 'function') {
      try {
        d.close();
      } catch (err) {}
    } else if (d) {
      d.classList.remove('active', 'animate', 'cart-drawer--editor-open');
    }
  }

  var fetchCartInflight = null;
  var fetchCartAt = 0;
  function fetchCart(force) {
    var now = Date.now();
    if (!force && fetchCartInflight && now - fetchCartAt < 400) return fetchCartInflight;
    fetchCartAt = now;
    fetchCartInflight = fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Hestia-Cart': '1' }
    }).then(function (r) {
      return r.json();
    }).then(function (cart) {
      lastCart = cart;
      return cart;
    }).finally(function () {
      setTimeout(function () { fetchCartInflight = null; }, 50);
    });
    return fetchCartInflight;
  }

  function getSections() {
    var d = getDrawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) {
          return s.id;
        });
      } catch (e) {}
    }
    return ['cart-drawer-theme-blocks', 'cart-icon-bubble'];
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Hestia-Cart': '1'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r
        .json()
        .then(function (data) {
          return { ok: r.ok, data: data };
        })
        .catch(function () {
          return { ok: r.ok, data: null };
        });
    });
  }

  function renderDrawerFromCartPayload(parsed) {
    var d = getDrawer();
    if (!d || !parsed || !parsed.sections) return false;
    if (typeof d.renderContents === 'function') {
      try {
        d.renderContents(parsed);
        return true;
      } catch (e) {}
    }
    return false;
  }

  function isGiftLine(item) {
    if (!item) return false;
    var vid = Number(item.variant_id);
    var pid = Number(item.product_id);
    if (ALL_GIFT_VARIANT_IDS.indexOf(vid) !== -1) return true;
    if (ALL_GIFT_PRODUCT_IDS.indexOf(pid) !== -1) return true;
    var handle = (item.handle || '').toLowerCase();
    return handle === 'makeup-bag' || handle === 'travel-makeup-bag' || handle === 'moosh-makeup-bag' || handle === 'mystery-gift';
  }

  function isHestiaLine(item) {
    return item && Number(item.product_id) === HESTIA_PRODUCT_ID;
  }

  function isBundleLine(item) {
    return isHestiaLine(item) || isGiftLine(item);
  }

  function hestiaQty(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isHestiaLine(i) ? i.quantity || 0 : 0);
    }, 0);
  }

  function giftLines(cart) {
    return (cart.items || []).filter(isGiftLine);
  }

  function bundleLines(cart) {
    return (cart.items || []).filter(isBundleLine);
  }

  function newDealId() {
    return 'hd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function getDealId(item) {
    if (!item) return null;
    var p = item.properties || {};
    return p._hestia_deal_id || null;
  }

  function isPaidStick(item) {
    return isHestiaLine(item) && Number(item.final_line_price || item.line_price || 0) > 0;
  }

  function isFreeStick(item) {
    return isHestiaLine(item) && Number(item.final_line_price || item.line_price || 0) === 0;
  }

  function isBagLine(item) {
    if (!item) return false;
    var pid = Number(item.product_id);
    var vid = Number(item.variant_id);
    return ALL_BAG_VARIANT_IDS.indexOf(vid) !== -1 || pid === GIFT_PRODUCT_IDS.bag || LEGACY_BAG_PRODUCT_IDS.indexOf(pid) !== -1;
  }

  function isMysteryLine(item) {
    if (!item) return false;
    return Number(item.variant_id) === GIFT_VARIANT_IDS.mystery || Number(item.product_id) === GIFT_PRODUCT_IDS.mystery;
  }

  /** One B1G3 deal from a trash trigger — never the whole cart when other deals remain. */
  function buildDealGroup(cart, trigger) {
    var items = (cart && cart.items) || [];
    if (!trigger) return [];
    var dealId = getDealId(trigger);
    if (dealId) {
      var tagged = items.filter(function (i) { return getDealId(i) === dealId; });
      if (tagged.length) return tagged;
    }
    var group = [trigger];
    var used = {};
    used[trigger.key] = true;
    function take(pred) {
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || used[it.key]) continue;
        if (pred(it)) {
          used[it.key] = true;
          group.push(it);
          return it;
        }
      }
      return null;
    }
    if (isHestiaLine(trigger)) {
      if (isPaidStick(trigger)) take(isFreeStick);
      else take(isPaidStick);
    } else {
      take(isPaidStick);
      take(isFreeStick);
    }
    take(isBagLine);
    take(isMysteryLine);
    return group;
  }


  function missingGifts(cart) {
    var present = {};
    giftLines(cart).forEach(function (i) {
      present[Number(i.variant_id)] = true;
      present[Number(i.product_id)] = true;
    });
    var missing = [];
    if (!present[GIFT_VARIANT_IDS.bag] && !present[GIFT_PRODUCT_IDS.bag]) missing.push(GIFT_VARIANT_IDS.bag);
    if (!present[GIFT_VARIANT_IDS.mystery] && !present[GIFT_PRODUCT_IDS.mystery]) {
      missing.push(GIFT_VARIANT_IDS.mystery);
    }
    return missing;
  }


  function wantsB1g3Bundle() {
    var activeSticky = document.querySelector('[data-hestia-sticky-opt].is-active');
    if (activeSticky) {
      return activeSticky.getAttribute('data-hestia-sticky-opt') === 'b1g3';
    }
    var sel = document.querySelector('.quantity-break-option.selected, label.quantity-break-option.selected');
    if (sel) {
      var t = (sel.textContent || '').toLowerCase();
      if (t.indexOf('get 3') !== -1 || t.indexOf('b1g3') !== -1) return true;
      if (t.indexOf('buy 1 get') !== -1) return true;
      // Misaligned legacy tiers that sticky maps as the deal
      if (t.indexOf('get 1 free') !== -1 || t.indexOf('get 2 free') !== -1) return true;
    }
    // Sticky bar defaults to B1G3 when present and buy1 is not pressed
    if (document.querySelector('[data-hestia-sticky-atc]')) {
      var buy1 = document.querySelector('[data-hestia-sticky-opt="buy1"][aria-pressed="true"], [data-hestia-sticky-opt="buy1"].is-active');
      return !buy1;
    }
    return false;
  }

  /** After ATC: if B1G3 deal selected, auto-add free stick + bag + mystery (no Claim click). */
  function ensureB1g3Bundle(cart) {
    if (!cart || claiming || syncing || removingBundle) return Promise.resolve(cart);
    if (!wantsB1g3Bundle()) return Promise.resolve(cart);
    if (hestiaQty(cart) < 1) return Promise.resolve(cart);
    var needStick = hestiaQty(cart) < 2;
    var gifts = missingGifts(cart);
    if (!needStick && !gifts.length) return Promise.resolve(cart);
    // Reuse claim path (adds stick if needed + missing gifts)
    return new Promise(function (resolve) {
      claimFreeGifts();
      // claimFreeGifts is async; poll briefly for completion
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (!claiming || tries > 40) {
          clearInterval(t);
          fetchCart().then(resolve);
        }
      }, 100);
    });
  }


  /** DOM: is this cart row part of the HESTIA bundle? */
  function rowIsBundle(row) {
    if (!row) return false;
    var text = (row.textContent || '').toLowerCase();
    if (text.indexOf('hestia') !== -1) return true;
    if (text.indexOf('makeup bag') !== -1) return true;
    if (text.indexOf('mystery gift') !== -1) return true;
    var btn = row.querySelector('[data-variant-id]');
    if (btn) {
      var vid = Number(btn.getAttribute('data-variant-id'));
      if (ALL_GIFT_VARIANT_IDS.indexOf(vid) !== -1) return true;
    }
    var link = row.querySelector('a[href*="/products/"]');
    if (link) {
      var href = (link.getAttribute('href') || '').toLowerCase();
      if (href.indexOf('hestia') !== -1 || href.indexOf('makeup-bag') !== -1 || href.indexOf('travel-makeup-bag') !== -1 || href.indexOf('moosh-makeup-bag') !== -1 || href.indexOf('mystery-gift') !== -1) {
        return true;
      }
    }
    return false;
  }

  /** Instant UI: hide every bundle row so trash feels immediate */
  function optimisticHideDealRows(keys) {
    var drawer = getDrawer();
    if (!drawer) return;
    var keySet = {};
    (keys || []).forEach(function (k) { keySet[k] = true; });
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      var keyEl = row.querySelector('[data-cart-item-key], [data-key]');
      var key = row.getAttribute('data-key') || (keyEl && (keyEl.getAttribute('data-cart-item-key') || keyEl.getAttribute('data-key')));
      if (key && keySet[key]) {
        row.style.display = 'none';
        row.setAttribute('data-hestia-removing', '1');
        return;
      }
      // If keys unknown, hide matching hestia/gift rows only when single deal
      if (!keys || !keys.length) return;
    });
  }

  function optimisticHideBundleRows() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      if (rowIsBundle(row)) {
        row.style.display = 'none';
        row.setAttribute('data-hestia-removing', '1');
      }
    });
  }

  function cartHasItems(cart) {
    if (!cart) return false;
    if (typeof cart.item_count === 'number') return cart.item_count > 0;
    if (cart.items && cart.items.length) return true;
    return false;
  }

  function clearInjectedEmptyUi(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-hestia-cart-empty]').forEach(function (n) {
      // Only remove engine-injected empty UI, not the theme empty host contents we may have replaced
      var host = n.closest('.cart-drawer-empty, .hestia-cart-empty-host');
      if (host && host.querySelector('[data-hestia-cart-empty]') === n && host.children.length === 1) {
        // leave host; just clear injected markup so theme empty can take over later
        n.remove();
        return;
      }
      n.remove();
    });
  }

  function applyCartToUi(cart) {
    lastCart = cart;
    ensureEmptyUi(cart);
    injectClaimUi(cart);
    var d = getDrawer();
    if (d) {
      if (!cartHasItems(cart)) d.classList.add('is-empty');
      else d.classList.remove('is-empty');
    }
  }

  function forceEmptyDrawerSections() {
    var ids = getSections();
    if (!ids || !ids.length) return Promise.resolve();
    var sep = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + sep + 'sections=' + encodeURIComponent(ids.join(','));
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Hestia-Cart': '1' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (sections) renderDrawerFromCartPayload({ sections: sections });
      })
      .catch(function () {});
  }

  function finishBundleRemoval(data) {
    removingBundle = false;
    syncing = false;
    if (data) {
      lastCart = data;
      renderDrawerFromCartPayload(data);
      applyCartToUi(data);
      return data;
    }
    return fetchCart().then(function (fresh) {
      applyCartToUi(fresh);
      return fresh;
    });
  }

  function domLooksLikeOnlyBundle() {
    var rows = document.querySelectorAll('cart-drawer .cart-item, #CartDrawer .cart-item');
    if (!rows.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (!rowIsBundle(rows[i])) return false;
    }
    return true;
  }

  function clearCartFast() {
    var sections = getSections();
    return postJson(cartUrl('cart/clear.js'), {
      sections: sections,
      sections_url: window.location.pathname
    }).then(function (res) {
      var data = (res && res.data) || { items: [], item_count: 0 };
      if (!data.items) {
        data.items = [];
        data.item_count = 0;
      }
      applyCartToUi(data);
      if (data.sections) {
        renderDrawerFromCartPayload(data);
        return finishBundleRemoval(data);
      }
      // Don't block UX on section HTML — paint empty now, refresh HTML in background
      ensureEmptyUi(data);
      finishBundleRemoval(data);
      forceEmptyDrawerSections();
      return data;
    });
  }

  /**
   * Remove ONE deal (trigger stick/gift + paired free stick + bag + mystery).
   * Clears cart only when that was the last remaining deal.
   */
  function removeOneDeal(triggerItem) {
    if (removingBundle) return Promise.resolve();
    removingBundle = true;
    syncing = true;

    return fetchCart()
      .then(function (cart) {
        var trigger = triggerItem;
        if (!trigger && lastCart && lastCart.items) {
          // fallback: first bundle line
          trigger = bundleLines(cart)[0];
        }
        // If trigger is a key/string from DOM, resolve item
        if (trigger && !trigger.key && typeof trigger === 'object' && trigger.getAttribute) {
          trigger = null;
        }
        var group = buildDealGroup(cart, trigger);
        if (!group.length) {
          group = bundleLines(cart);
        }
        var updates = {};
        group.forEach(function (line) {
          if (line && line.key) updates[line.key] = 0;
        });
        var keys = Object.keys(updates);
        if (!keys.length) return finishBundleRemoval(cart);

        optimisticHideDealRows(keys);

        var remaining = (cart.items || []).filter(function (i) { return !updates[i.key]; });
        if (!remaining.length) {
          var drawer = getDrawer();
          if (drawer) drawer.classList.add('is-empty');
          ensureEmptyUi({ items: [], item_count: 0 });
          return clearCartFast();
        }

        return postJson(cartUrl('cart/update.js'), {
          updates: updates,
          sections: getSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          return finishBundleRemoval(res && res.data);
        });
      })
      .catch(function () {
        removingBundle = false;
        syncing = false;
        return fetchCart().then(applyCartToUi);
      });
  }

  /** Legacy name — now removes one deal, not every HESTIA line. */
  function removeEntireBundle(triggerItem) {
    return removeOneDeal(triggerItem);
  }

  window.__hestiaRemoveBundle = removeOneDeal;
  window.__hestiaRemoveOneDeal = removeOneDeal;

  /** If gifts landed without a stick, add the PDP-selected HESTIA variant; otherwise purge gifts */
  function recoverBundleOrPurge(cart) {
    var stickId = null;
    try {
      if (typeof window.Elixir_GetProductFormVariantId === 'function') {
        stickId = window.Elixir_GetProductFormVariantId();
      }
      if (!stickId) {
        var inp = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name^="items["][name*="[id]"]');
        if (inp && inp.value) stickId = inp.value;
      }
    } catch (e) {}
    stickId = stickId ? Number(stickId) : null;
    if (!stickId) return removeOrphanGifts(cart);

    syncing = true;
    return postJson(cartUrl('cart/add.js'), {
      items: [{ id: stickId, quantity: 1, properties: { _hestia_bundle: 'b1g3', _hestia_deal_id: newDealId() } }],
      sections: getSections(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        syncing = false;
        if (!res.ok) return removeOrphanGifts(cart);
        var data = res.data;
        if (data && data.items) {
          lastCart = data.item_count != null ? data : { items: data.items, item_count: data.items.length };
        }
        // Re-fetch authoritative cart — BXGY may add free stick
        return fetchCart().then(function (fresh) {
          if (hestiaQty(fresh) === 0) return removeOrphanGifts(fresh);
          applyCartToUi(fresh);
          var d = getDrawer();
          if (!d || !d.classList.contains('active')) openDrawer();
          return fresh;
        });
      })
      .catch(function () {
        syncing = false;
        return removeOrphanGifts(cart);
      });
  }


  function removeOrphanGifts(cart) {
    if (!cart || syncing || removingBundle) return Promise.resolve(cart);
    if (hestiaQty(cart) > 0) return Promise.resolve(cart);
    var gifts = giftLines(cart);
    if (!gifts.length) return Promise.resolve(cart);

    syncing = true;
    var updates = {};
    gifts.forEach(function (g) {
      updates[g.key] = 0;
    });
    return postJson(cartUrl('cart/update.js'), {
      updates: updates,
      sections: getSections(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        syncing = false;
        var data = res && res.data;
        if (data) {
          lastCart = data;
          renderDrawerFromCartPayload(data);
          applyCartToUi(data);
          return data;
        }
        return cart;
      })
      .catch(function () {
        syncing = false;
        return cart;
      });
  }

  function claimFreeGifts() {
    if (claiming) return;
    claiming = true;
    var btn = document.querySelector('[data-hestia-claim-gifts]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding gifts…';
    }

    fetchCart()
      .then(function (cart) {
        var sticks = (cart.items || []).filter(isHestiaLine);
        if (!sticks.length) throw new Error('no-stick');
        var primary = sticks[0];
        var items = [];
        var dealId = getDealId(primary) || newDealId();
        if (hestiaQty(cart) < 2) {
          items.push({
            id: primary.variant_id,
            quantity: 1,
            properties: { _hestia_bundle: 'b1g3', _hestia_deal_id: dealId }
          });
        }
        missingGifts(cart).forEach(function (id) {
          items.push({
            id: id,
            quantity: 1,
            properties: { _free_item: 'true', _hestia_gift: 'true', _hestia_bundle: 'b1g3', _hestia_deal_id: dealId }
          });
        });
        if (!items.length) return cart;
        return postJson(cartUrl('cart/add.js'), {
          items: items,
          sections: getSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          // cart/add.js multi-item payloads often omit item_count and only return added lines.
          // Always re-fetch the full cart, then paint sections from the add response (or refresh).
          if (res.data && res.data.sections) {
            renderDrawerFromCartPayload(res.data);
          }
          return fetchCart().then(function (fresh) {
            if (!(res.data && res.data.sections)) {
              return forceEmptyDrawerSections().then(function () {
                return fresh;
              });
            }
            return fresh;
          });
        });
      })
      .then(function (cart) {
        claiming = false;
        applyCartToUi(cart);
        openDrawer();
      })
      .catch(function () {
        claiming = false;
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.textContent = 'Claim FREE Gifts';
        }
      });
  }

  function buildClaimCard(cart) {
    if (hestiaQty(cart) < 1 || missingGifts(cart).length === 0) return null;
    var el = document.createElement('div');
    el.className = 'hestia-claim-gifts';
    el.setAttribute('data-hestia-claim-card', '1');
    el.innerHTML =
      '<div class="hestia-claim-gifts__badge">Limited offer</div>' +
      '<div class="hestia-claim-gifts__copy">' +
      '<strong>Claim your FREE gifts</strong>' +
      '<p>Makeup Bag + Mystery Gift — included with Buy 1 Get 3 Free. Same price as one stick.</p>' +
      '</div>' +
      '<button type="button" class="hestia-claim-gifts__btn" data-hestia-claim-gifts>Claim FREE Gifts</button>';
    return el;
  }

  function injectClaimUi(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('[data-hestia-claim-card]').forEach(function (n) {
      n.remove();
    });
    if (!cartHasItems(cart) || hestiaQty(cart) < 1) return;
    var card = buildClaimCard(cart);
    if (!card) return;
    var host =
      drawer.querySelector('.cart-drawer-upsell-sections') ||
      drawer.querySelector('.drawer__footer') ||
      drawer.querySelector('cart-drawer-items') ||
      drawer.querySelector('.drawer__inner');
    if (!host) return;
    if (host.classList.contains('drawer__footer')) host.insertBefore(card, host.firstChild);
    else host.appendChild(card);
    var btn = card.querySelector('[data-hestia-claim-gifts]');
    if (btn) btn.addEventListener('click', claimFreeGifts);
  }

  function emptyUiHtml() {
    var shopUrl = '/products/hestia%C2%AE-color-changing-foundation-stick';
    return (
      '<div class="hestia-cart-empty" data-hestia-cart-empty>' +
      '<div class="hestia-cart-empty__header">' +
      '<h2 class="hestia-cart-empty__title">Your Cart <span class="hestia-cart-empty__count">(0)</span></h2>' +
      '<button class="drawer__close hestia-cart-empty__close" type="button" data-hestia-cart-close aria-label="Close">' +
      '<span aria-hidden="true" style="font-size:22px;line-height:1;">×</span></button></div>' +
      '<div class="hestia-cart-empty__body">' +
      '<p class="hestia-cart-empty__eyebrow">You\'re in your cart</p>' +
      '<h3 class="hestia-cart-empty__heading">Your bag is empty</h3>' +
      '<p class="hestia-cart-empty__text">Add HESTIA® and unlock <strong>Buy 1 Get 3 Free</strong> — 2 sticks + Makeup Bag + Mystery Gift.</p>' +
      '<a class="hestia-cart-empty__cta" href="' +
      shopUrl +
      '" data-hestia-empty-shop>Shop HESTIA®</a>' +
      '<p class="hestia-cart-empty__trust">Free express shipping · 30-day money-back</p>' +
      '</div></div>'
    );
  }

  function ensureEmptyUi(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    // Orphan gifts (bag/mystery without a stick) must never linger — clear then paint empty
    if (cart && hestiaQty(cart) === 0 && giftLines(cart).length) {
      removeOrphanGifts(cart);
      return;
    }

    var isEmpty = !cartHasItems(cart);
    if (!isEmpty) {
      drawer.classList.remove('is-empty');
      // Critical: remove any injected empty UI left over from a stale cart/add payload
      // (multi-item add.js often omits item_count, which used to leave empty+filled stacked).
      clearInjectedEmptyUi(drawer);
      return;
    }
    drawer.classList.add('is-empty');
    if (drawer.querySelector('[data-hestia-cart-empty]')) return;

    var blank =
      drawer.querySelector('.cart-drawer-empty') || drawer.querySelector('.cart-drawer-empty__blocks');
    if (blank && blank.classList && blank.classList.contains('cart-drawer-empty')) {
      blank.innerHTML = emptyUiHtml();
      return;
    }
    if (blank && blank.classList && blank.classList.contains('cart-drawer-empty__blocks')) {
      blank.innerHTML = emptyUiHtml();
      return;
    }
    // Never inject empty UI on top of a filled drawer shell — only when empty zone exists
    // or drawer currently has no line-item shell.
    if (inner.querySelector('cart-drawer-items, .cart-drawer-header-blocks, .drawer__footer')) {
      return;
    }
    inner.insertAdjacentHTML('afterbegin', emptyUiHtml());
  }

  function scheduleOrphanCheck(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      if (removingBundle || syncing) return;
      fetchCart().then(function (cart) {
        return removeOrphanGifts(cart).then(function (next) {
          applyCartToUi(next || cart);
        });
      });
    }, typeof delay === 'number' ? delay : 180);
  }

  function isBundleRemoveEvent(e) {
    var removeEl =
      e.target.closest &&
      e.target.closest('cart-remove-button, button.cart-remove-button, .cart-remove-button');
    if (!removeEl || !removeEl.closest('cart-drawer, cart-items, #CartDrawer')) return false;
    var row = removeEl.closest('.cart-item, [id*="CartDrawer-Item"], tr');
    return rowIsBundle(row);
  }

  function resolveTriggerItemFromEvent(e) {
    var row = e.target && e.target.closest && e.target.closest('.cart-item, [id*="CartDrawer-Item"], tr');
    if (!row || !lastCart || !lastCart.items) return null;
    var idAttr = row.id || '';
    var m = idAttr.match(/CartDrawer-Item-(\d+)/) || idAttr.match(/CartItem-(\d+)/);
    if (m) {
      var idx = Number(m[1]) - 1;
      if (lastCart.items[idx]) return lastCart.items[idx];
    }
    var keyEl = row.querySelector('[data-cart-item-key], [data-key]');
    var key = row.getAttribute('data-key') || (keyEl && (keyEl.getAttribute('data-cart-item-key') || keyEl.getAttribute('data-key')));
    if (key) {
      for (var i = 0; i < lastCart.items.length; i++) {
        if (lastCart.items[i].key === key) return lastCart.items[i];
      }
    }
    var vidEl = row.querySelector('[data-variant-id]');
    var vid = vidEl && Number(vidEl.getAttribute('data-variant-id'));
    if (vid) {
      for (var j = 0; j < lastCart.items.length; j++) {
        if (Number(lastCart.items[j].variant_id) === vid && isBundleLine(lastCart.items[j])) {
          return lastCart.items[j];
        }
      }
    }
    return bundleLines(lastCart)[0] || null;
  }

  function onBundleTrash(e) {
    if (!isBundleRemoveEvent(e)) return false;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var trigger = resolveTriggerItemFromEvent(e);
    removeOneDeal(trigger);
    return true;
  }

  function bindBundleTrash() {
    // pointerdown + click capture — beat theme CartRemoveButton every time
    document.addEventListener('pointerdown', onBundleTrash, true);
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest && e.target.closest('.drawer__close, [data-hestia-cart-close]');
      if (closeBtn && closeBtn.closest('cart-drawer')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        return;
      }
      var overlay = e.target.closest && e.target.closest('#CartDrawer-Overlay, .cart-drawer__overlay');
      if (overlay) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      onBundleTrash(e);
    }, true);

    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') closeDrawer();
    });

    // If theme still calls updateQuantity(line, 0) on a HESTIA row, clear whole bundle
    function patchQty() {
      var nodes = document.querySelectorAll('cart-drawer-items, cart-items');
      nodes.forEach(function (el) {
        if (!el || el.__hestiaQtyPatched || typeof el.updateQuantity !== 'function') return;
        el.__hestiaQtyPatched = true;
        var orig = el.updateQuantity.bind(el);
        el.updateQuantity = function (line, quantity, event) {
          if (Number(quantity) === 0) {
            var row =
              document.getElementById('CartDrawer-Item-' + line) ||
              document.querySelector('[id="CartDrawer-Item-' + line + '"]') ||
              document.querySelector('#CartItem-' + line) ||
              (event && event.target && event.target.closest && event.target.closest('.cart-item'));
            if (rowIsBundle(row)) {
              var trigger = null;
              if (lastCart && lastCart.items) {
                var idMatch = (row.id || '').match(/(\d+)$/);
                if (idMatch) trigger = lastCart.items[Number(idMatch[1]) - 1] || null;
              }
              removeOneDeal(trigger);
              return;
            }
          }
          return orig.apply(null, arguments);
        };
      });
    }
    patchQty();
    setTimeout(patchQty, 500);
    setTimeout(patchQty, 1500);

    var obs = new MutationObserver(function () {
      var d = getDrawer();
      if (!d) return;
      if (d.classList.contains('active')) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }
      patchQty();
    });
    var d = getDrawer();
    if (d) obs.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function isCartMutationUrl(urlStr) {
    return (
      urlStr.indexOf('/cart/add') !== -1 ||
      urlStr.indexOf('/cart/change') !== -1 ||
      urlStr.indexOf('/cart/update') !== -1 ||
      urlStr.indexOf('/cart/clear') !== -1
    );
  }

  function isOurRequest(args) {
    try {
      var opts = args[1] || {};
      var h = opts.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return h.get('X-Hestia-Cart') === '1';
      return h['X-Hestia-Cart'] === '1' || h['x-hestia-cart'] === '1';
    } catch (e) {
      return false;
    }
  }

  function wrapFetch() {
    var orig = window.fetch;
    if (!orig || window.__hestiaFetchWrappedV5) return;
    window.__hestiaFetchWrappedV5 = true;
    window.__hestiaFetchWrapped = true;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var urlStr = String(url);
      var ours = isOurRequest(args);

      return orig.apply(this, args).then(function (res) {
        try {
          if (ours || !isCartMutationUrl(urlStr) || !res.ok) return res;

          if (urlStr.indexOf('/cart/add') !== -1) {
            openDrawer();
            res
              .clone()
              .json()
              .then(function (data) {
                if (data && data.items) {
                  // Normalize: add.js may return only added lines and omit item_count
                  lastCart =
                    data.item_count != null
                      ? data
                      : { items: data.items, item_count: data.items.length };
                  // Gift-only cart is invalid — try to attach the selected HESTIA stick, else purge gifts
                  if (hestiaQty(lastCart) === 0 && giftLines(lastCart).length) {
                    return recoverBundleOrPurge(lastCart);
                  }
                  // Prefer authoritative cart, then auto-complete B1G3 (stick+gifts)
                  return fetchCart().then(function (fresh) {
                    var cart = fresh || lastCart;
                    return ensureB1g3Bundle(cart).then(function (next) {
                      applyCartToUi(next || cart);
                      return next || cart;
                    });
                  });
                }
                scheduleOrphanCheck(80);
              })
              .catch(function () {});
            return res;
          }

          // Non-bundle change/update from theme — soft orphan check only
          if (!removingBundle) scheduleOrphanCheck(80);
        } catch (e) {}
        return res;
      });
    };
  }

  /** Block checkout when cart is gift-only; clear orphans first */
  function guardCheckout(e) {
    var t = e.target && e.target.closest && e.target.closest(
      'button[name="checkout"], [name="checkout"], .cart__checkout-button, #CartDrawer-Checkout, a[href="/checkout"]'
    );
    if (!t) return;
    var run = function (cart) {
      if (!cart) return;
      // Incomplete B1G3 — block checkout, inject free stick + gifts, reopen drawer
      if (hestiaQty(cart) > 0 && wantsB1g3Bundle()) {
        var incomplete = hestiaQty(cart) < 2 || missingGifts(cart).length > 0;
        if (incomplete) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          ensureB1g3Bundle(cart).then(function () {
            openDrawer();
          });
          return;
        }
      }
      if (hestiaQty(cart) > 0) return;
      if (!giftLines(cart).length) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      removeOrphanGifts(cart).then(function () {
        openDrawer();
      });
    };
    if (lastCart) run(lastCart);
    else fetchCart().then(run);
  }

  function bindCheckoutGuard() {
    if (window.__hestiaCheckoutGuard) return;
    window.__hestiaCheckoutGuard = true;
    document.addEventListener('click', guardCheckout, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      // form checkout submit — same gift-only guard
      if (lastCart && hestiaQty(lastCart) === 0 && giftLines(lastCart).length) {
        e.preventDefault();
        e.stopPropagation();
        removeOrphanGifts(lastCart);
      }
    }, true);
  }


  function injectEmptyStackFixCss() {
    if (document.getElementById('hestia-empty-stack-fix')) return;
    var style = document.createElement('style');
    style.id = 'hestia-empty-stack-fix';
    style.textContent =
      'cart-drawer:not(.is-empty) .hestia-cart-empty,' +
      'cart-drawer:not(.is-empty) [data-hestia-cart-empty],' +
      'cart-drawer:not(.is-empty) .drawer__inner > .hestia-cart-empty{' +
      'display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;overflow:hidden!important;pointer-events:none!important;}' +
      'cart-drawer:not(.is-empty) .drawer__inner{' +
      'display:flex!important;flex-direction:column!important;height:100%!important;max-height:100%!important;min-height:0!important;overflow:hidden!important;}' +
      'cart-drawer:not(.is-empty) .drawer__inner > *:has(cart-drawer-items){' +
      'flex:1 1 0%!important;min-height:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;}' +
      'cart-drawer:not(.is-empty) cart-drawer-items{' +
      'display:flex!important;flex-direction:column!important;flex:1 1 0%!important;min-height:0!important;' +
      'overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;' +
      'overscroll-behavior:contain!important;touch-action:pan-y!important;}' +
      'cart-drawer:not(.is-empty) cart-drawer-items .cart-drawer__form,' +
      'cart-drawer:not(.is-empty) cart-drawer-items .scrollable-contents{' +
      'flex:1 1 auto!important;min-height:0!important;flex-wrap:nowrap!important;width:100%!important;}' +
      'cart-drawer:not(.is-empty) .drawer__footer{display:block!important;flex-shrink:0!important;}' +
      'html.hestia-cart-open,html.hestia-scroll-locked,html:has(cart-drawer.active){' +
      'overflow:hidden!important;overscroll-behavior:none!important;height:100%!important;}' +
      'body.hestia-cart-open,body:has(cart-drawer.active){' +
      'overflow:hidden!important;overscroll-behavior:none!important;width:100%!important;touch-action:none;}' +
      'body.hestia-scroll-locked-fixed{position:fixed!important;left:0!important;right:0!important;width:100%!important;}' +
      'cart-drawer.active,cart-drawer.active cart-drawer-items{touch-action:pan-y!important;}';
    document.head.appendChild(style);
  }

  function init() {
    injectEmptyStackFixCss();
    bindTouchScrollGuard();
    document.addEventListener('cart-drawer:open', function () { lockPageScroll(); });
    document.addEventListener('cart-drawer:close', function () { unlockPageScroll(); });
    wrapFetch();
    bindBundleTrash();
    bindCheckoutGuard();
    // Warm cart cache + clear gift-only leftovers
    fetchCart().then(function (cart) {
      return removeOrphanGifts(cart).then(function (next) {
        applyCartToUi(next || cart);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
